import React, { forwardRef, useContext } from 'react';
import classnames from 'classnames';
import { ReactSVG } from 'react-svg';
import UIOptimisationRecommenderRightArrow from '@/assets/img/ui-optimisation-recommender/ui-optimisation-recommender-right-arrow.svg';
import { TRACKING_TYPE, TRACKING_MSG_TYPE } from '@/utils/constants';
import { Intent } from './types';
import { IntentContextStore } from './intentContext';
import './style.scss';
import { IntentSelectorProps } from '.';

interface IntentItemProps {
  item: Intent;
  className?: string;
  disabled?: boolean;
  index: number;
  onIntentClick: (index: number) => void;
  useUIOptimisationRecommender?: IntentSelectorProps['useUIOptimisationRecommender'];
}

const trackingName = TRACKING_TYPE.STANDARDIZE_BUTTON;

const IntentItem = (props: IntentItemProps, parentRef: any) => {
  const { item, disabled, index, onIntentClick, useUIOptimisationRecommender } = props;
  const IntentContext = useContext(IntentContextStore);
  const { isHistory, historySessionId, sessionId, historyDialogueId, dialogueId, nodePointId } = IntentContext;

  return (
    <div
      className={classnames('intent-item', { disabled })}
      onClick={() => !disabled && onIntentClick(index)}
      ref={(el) => {
        parentRef.current[index] = el;
      }}
      data-trackingname={trackingName}
      data-trackingdata={JSON.stringify({
        chat_session_id: isHistory ? historySessionId : sessionId,
        chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
        node_point_id: nodePointId,
        button_details: [
          {
            button_type: item.button_type,
            button_id: item.button_id,
            button_text: item.intent_text,
          },
        ],
        if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
      })}
    >
      <div className="intent-item-text">
        {useUIOptimisationRecommender ? <>
          <div className="intent-item-text-ui-optimisation-recommender">{item.intent_text}</div>
          <ReactSVG src={UIOptimisationRecommenderRightArrow} style={{ width: 12, height: '100%', marginLeft: 8 }} />
        </>
          : item.intent_text}
      </div>
    </div>
  );
};

export default forwardRef(IntentItem);
